import { createActionGroup, props } from '@ngrx/store';
import type { Footnote } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'footnotes',
    events: {
        'Add Footnotes': props<{ footnotes: Footnote[]; removeWithIdPrefix?: string }>(),
        'Register Active Footnotes': props<{ footnotes: string[] }>(),
        'Unregister Active Footnotes': props<{ footnotes: string[] }>(),
    },
});
